import React, { useEffect } from 'react'
import { Provider } from 'react-redux'
import store from './redux/store'
import './css/App.css'
import './css/Mobile.css'
import Routes from './Routes'
import TutorialModal from './components/commons/TutorialModal'

function App() {
    useEffect(() => {
        const applyTheme = (mode) => {
            const root = document.documentElement
            root.setAttribute('data-theme', mode === 'dark' ? 'dark' : 'light')
        }

        const syncTheme = () => {
            const state = store.getState()
            const mode = state?.theme?.mode || 'light'
            applyTheme(mode)
            if (typeof window !== 'undefined') {
                window.localStorage.setItem('themeMode', mode)
            }
        }

        syncTheme()
        const unsubscribe = store.subscribe(syncTheme)

        return () => unsubscribe()
    }, [])

    return (
        <Provider store={store}>
            <div className="App">
                <TutorialModal />
                <Routes />
            </div>
        </Provider>
    )
}

export default App
